<template>
  <div>
    <!-- Loading state -->
    <template v-if="isLoading">
      <v-skeleton-loader
        type="table"
        class="mb-4"
      ></v-skeleton-loader>
    </template>

    <!-- Error state - No reports available -->
    <template v-else-if="!isReportsAvailable">
      <div class="error-message pa-4">
        <h3 class="text-h6 mb-4">
          <i class="fas fa-exclamation-circle text-error mr-2"></i>
            {{ $t('page.report.alert.title') }}
        </h3>
        
        <p class="mb-4">
          {{ $t('page.report.alert.description') }}
        </p>
        
        <p class="mb-4 no-bullets">
          <span>{{ $t('page.report.alert.option_1') }}</span><br/>
          <span>{{ $t('page.report.alert.option_2') }}</span><br/>
          <span>{{ $t('page.report.alert.option_3') }}</span>
        </p>
        
        <p class="text-caption">
          {{ $t('page.report.alert.note') }}
        </p>
      </div>
    </template>

    <!-- Content when reports are available -->
    <template v-else>
      <div class="reportView pa-3">
        <div class="legacy-report">
          <a
            :href="`${root}/admin/promoterReports` "
            target="_blank"
            rel="noopener noreferrer"
          >{{ $t('page.report.legacy-report') }}</a>
        </div>
        <v-row no-gutters justify="center">
          <v-col class="py-0">
            <v-row no-gutters class="py-0">
              <v-col>
                <v-row no-gutters>
                  <v-col class="py-0">
                    <v-row no-gutters justify="center">
                      <v-expansion-panels accordion multiple :value="valuesExpand">
                        <v-expansion-panel v-for="(item,i) in menu" :key="i" v-model="item.open">
                          <v-expansion-panel-header
                            class="my-1"
                            color="accent"
                          >
                            <p
                              depressed
                              class="font-weight-bold text-left text-uppercase text-customizer-exp"
                            >{{ item.name }}</p>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <component :is="item.component"></component>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </template>

    <NotificationAlert 
      v-if="isShowAlert" 
      :notificationMessage="msgAlert" 
      @cancel="closeAlert" 
      type='warning'
    />

  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import Membership from "@/components/reports/Membership.vue";
import Sales from "@/components/reports/Sales.vue";
import EventCosts from "@/components/reports/EventCosts.vue";
import Events from "@/components/reports/Events.vue";
import Races from "@/components/reports/Races.vue";
import Series from "@/components/reports/Series.vue";
import { mapState } from "vuex";
import NotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
  mixins: [apiCalls], //for api redundant operations
  components: {
    Events,
    Membership,
    Sales,
    EventCosts,
    Races,
    Series,
    NotificationAlert
  },
  data() {
    return {
      navigationBGColor: "#FFF",
      valuesExpand: [0]
    };
  },
  computed: {
    menu() {
      const menu =  [
        {
          name: this.$t("page.report.races"),
          component: "Races",
          open: true,
          isEnabled: this.isReportEnabled('races')
        },
        {
          name: this.$t("page.report.events"),
          component: "Events",
          open: false,
          isEnabled: this.isReportEnabled('events')
        },
        {
          name: this.$t("page.report.series"),
          component: "Series",
          open: false,
          isEnabled: this.isReportEnabled('series')
        },
        {
          name: this.$t("page.report.membership"),
          component: "Membership",
          open: false,
          isEnabled: this.isReportEnabled('membership')
        },
        {
          name: this.$t("page.report.sales"),
          component: "Sales",
          open: false,
          isEnabled: this.isReportEnabled('sales')
        },
        {
          name: this.$t("page.report.event-costs"),
          component: "EventCosts",
          open: false,
          isEnabled: this.isReportEnabled('registrationCosts')
        }
      ];
      return menu.filter(item => item.isEnabled);
    },
    ...mapState({
      loadingReport: (state) => state.reports.loadingReport,
      reportConfig: (state) => state.reports.reportConfig,
      isShowAlert: (state) => state.reports.isShowAlert,
      msgAlert: (state) => state.reports.msgAlert
    }),
    isLoading() {
      return this.loadingReport;
    },
    isReportsAvailable() {
      if (!this.reportConfig) return false;

      let totalEnabled = 0;
      const categoryStats = {};

      Object.entries(this.reportConfig).forEach(([categoryName, category]) => {
        if (category.reports && Array.isArray(category.reports)) {
          const enabledInCategory = category.reports.filter(report => report.isEnabled).length;
          totalEnabled += enabledInCategory;
          
          categoryStats[categoryName] = {
            total: category.reports.length,
            enabled: enabledInCategory
          };
        }
      });

      return totalEnabled > 0;
    }
  },
  created: function() { 
    this.navigationBGColor = "#ccc";
    this.getReportsSettings();
  },
  methods: {
    async getReportsSettings() {
      const response = await this.api("get", "/api/v1/promoter/getPromoterReportSettings", {});
      this.$store.commit('reports/SET_LOADING', false);
      if(response.success) {
        this.$store.commit('reports/SET_REPORT_CONFIG', response.data);
      } else {
        //this.reportConfig = [];
      }
    },
    isReportEnabled(reportId) {
      return this.reportConfig[reportId].reports.find(report => report.isEnabled) || false;
    },
    closeAlert() {
      this.$store.commit('reports/SET_SHOW_ALERT', false);
    }
  }
};
</script>

<style scoped>
.btn.btn-info.btn-block {
  font-size: 16px;
}

.remaining-account-credits {
  font-size: 44px;
  font-weight: bold;
  text-align: left;
}

.legacy-report {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: var(--v-primary-base) !important;
  margin-right: 4%;
}
@media (min-width: 1024px) {
  .breadcrumb-c{display: none !important;}
}
.text-error {
  color: #ff5252; /* Color de error de Vuetify */
}
</style>
